import { createContext, useContext, useState, useEffect } from "react";

// Create Context
const AuthContext = createContext();

// Provider
export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [user, setUser] = useState(null);
  const [merchantUser, setMerchantUser] = useState(null);

  useEffect(() => {
    const authToken = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    const merchantUserData = localStorage.getItem("merchantUser");
    if (authToken) {
      setAuthToken(authToken);
    }
    if (userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (error) {
        console.error("Failed to parse user data: ", error);
      }
    }
    if (merchantUserData) {
      try {
        setMerchantUser(JSON.parse(merchantUserData));
      } catch (error) {
        console.error("Failed to parse merchant user data: ", error);
      }
    }
  }, []);

  const login = (authData) => {
    localStorage.setItem("authToken", authData.token);
    setAuthToken(authData.token);
    if (authData.user) {
      const userData = {
        ...authData.user,
        username: authData.user.username || authData.user.name,
        shopname: authData.user.shopname,
        merchantid: authData.user.merchantid,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);
    }

    // Save merchant user data if present
    if (authData.merchantUser) {
      localStorage.setItem(
        "merchantUser",
        JSON.stringify(authData.merchantUser),
      );
      setMerchantUser(authData.merchantUser);
    }
  };

  const logout = () => {
    // Clear all auth-related data from localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    localStorage.removeItem("merchantUser");
    localStorage.removeItem("username");
    localStorage.removeItem("phone");
    localStorage.removeItem("email");
    localStorage.removeItem("shopname");
    localStorage.removeItem("userid");
    localStorage.removeItem("merchantid");
    localStorage.removeItem("token");

    // Reset all state
    setAuthToken(null);
    setUser(null);
    setMerchantUser(null);
  };

  const token = authToken;
  const districtMerchantId = merchantUser?.district_merchant_id || null;
  const merchantId = merchantUser?.merchant_id || user?.merchantid || null;
  const userId = user?.userid || merchantUser?.merchant_id || null;

  return (
    <AuthContext.Provider
      value={{
        authToken: token,
        login,
        logout,
        user,
        merchantUser,
        merchantId,
        districtMerchantId,
        userId,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook
export const useAuth = () => useContext(AuthContext);
